<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card card-form">
          <div class="card-header">
            <div class="row">
              <div class="col">
<!--                <h4 class="card-title float-left" v-if="companyOrder.id!=null">{{ $t('companyTariff.titleEdit') }}</h4>-->
                <h4 class="card-title float-left">{{$t('companyManage.companyOrder.addNew')}}</h4>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-8">
                <div class="form-group pr-3">
                  <label>{{ $t('companyManage.companyOrder.companyClient') }}<span class="red">*</span></label>
                  <CompanyClientSelect :value="companyOrder.companyClient"
                                       v-model="companyOrder.companyClient"></CompanyClientSelect>
                  <div class="red" v-if="$v.companyOrder.companyClient.$error">
                    {{ $t('companyManage.companyOrder.companyClient') }}
                  </div>
                </div>
                <div class="form-group pr-3">
                  <label>{{$t('companyTariff.companyTariffType')}}<span class="red">*</span></label>
                  <CompanyTariffTypeSelect :value="companyOrder.companyTariffType" v-model="companyOrder.companyTariffType"></CompanyTariffTypeSelect>
                  <div class="red" v-if="$v.companyOrder.companyTariffType.$error">
                    {{$t('companyTariff.companyTariffType')}}
                  </div>
                  <div class="font-weight-bold">
                    <label class="color-black" v-if="companyOrder.companyTariffType && companyOrder.companyTariffType.price">{{companyOrder.companyTariffType.price | currency('', 2, { thousandsSeparator: ' ' })}}</label>
                  </div>
                </div>
                <div class="form-group">
                  <label>{{$t('companyTariff.qty')}}<span class="red">*</span></label>
                  <numeric-input v-model="companyOrder.qty" :placeholder="$t('companyTariff.qty')">
                  </numeric-input>
                  <div class="red" v-if="$v.companyOrder.qty.$error">
                    {{$t('companyTariff.qty')}}
                  </div>
                </div>
                <div class="form-group">
                  <label>{{$t('companyManage.companyOrder.feeService')}}: </label><br/>
                  <label class="color-black ct-orange" v-if="companyOrder.companyTariffType && companyOrder.companyTariffType.price">
                    {{companyOrder.qty}} x {{companyOrder.companyTariffType.price}} = {{companyOrder.companyTariffType.price * companyOrder.qty  | currency('', 2, { thousandsSeparator: ' ' })}}
                  </label>
                </div>
                <div class="form-group" v-if="companyOrder.amount">
                  <label class="font-weight-bold badge-green">{{companyOrder.amount}}</label>
                </div>
                <div class="form-group">
                  <label>{{ $t('companyTariff.description') }}<span class="red">*</span></label>
                  <textarea
                      cols="30" rows="3"
                      class="form-control"
                      v-model="companyOrder.description"
                  ></textarea>
                </div>


              </div>
            </div>
            <div class="row mt-5">
              <div class="col-12 btns-box">
                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                  {{ $t("action.cancel") }}
                </button>
                <button class="all-btn add-btn" @click="save"
                        :disabled="processing" v-if="save">
                  {{ $t("action.save") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {required} from 'vuelidate/lib/validators';
import initFilterModel from '@/shared/filter';
// import DatePicker from 'vuejs-datepicker';
import {formatDate, parseDate} from '@/shared/utils';
import CompanyClientSelect from '@/views/company/company-personal-cabinet/CompanyClientSelect'
import CompanyTariffTypeSelect from '@/views/company/CompanyTariffTypeSelect'


export default {
  name: "CompanyOrderPieceAddEditView",
  components: {
    CompanyClientSelect,
    CompanyTariffTypeSelect
  },
  data() {
    return {
      parseDate: parseDate,
      formatDate: formatDate,
      processing: false,
      loading: {
        isDocQrLoading: false,
      },
      ownerFilter: initFilterModel(),
      editIndex: null,
      loadingExcelCalc: false,
      companyOrder: {
        id: null,
        description: null,
        companyTariffType: null,
        qty: null
      },
      itemFilter: initFilterModel(),
      results: null
    }
  },
  validations() {
    return {
      companyOrder: {
        companyClient: {
          required: required
        },
        companyTariffType: {
          required: required
        },
        qty: {
          required: required
        }
      }
    }
  },
  methods: {
    init() {
      const vm = this;
      const id = this.$route.params.id;

      if (id && id > 0) {
        this.$http.get('/company-order/' + id)
            .then(res => {
              console.log(res);
              vm.companyOrder = res.data;
              this.processing = false;
            }, () => {
              this.$swal({
                title: this.$t('messages.common.error'),
                text: this.$t('messages.fixedExpense.error'),
                type: 'error'
              });
              this.processing = false;
            });
      }
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.processing = true;
      this.$http.post('/company-order/save-piece', this.companyOrder)
          .then(res => {
            console.log(res)
            const status = res.data.status;
            if (status==='SUCCESS') {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: res.data.message,
                type: 'success'
              });
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: res.data.message,
                type: 'warning'
              });
            }
            this.$router.push('/company-manage/company-personal-cabinet');
            this.processing = false;
          }, () => {
            this.$swal({
              title: this.$t('messages.common.error'),
              text: this.$t('messages.companyOrder.error'),
              type: 'error'
            });
            this.processing = false;
          })

    },
    cancel() {
      this.$router.push('/company-manage/company-personal-cabinet');
    },
    changeStartDate(/*$event*/) {
      if (this.companyOrder.startDate >= this.companyOrder.endDate) {
        // this.companyOrder.startDate = this.companyOrder.endDate;
        this.$swal({
          title: this.$t('messages.common.warning'),
          text: formatDate(this.companyOrder.endDate) + ' дан олдинги сана танлаш мумкин эмас',
          type: 'warning'
        });
      }
    }

  },
  computed: {},
  created() {
    this.init();
  }
}
</script>

<style scoped>
.custom {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

.custom td, .custom th {
  border: 1px solid #ddd;
  padding: 4px;
}

.custom tr:nth-child(even) {
  background-color: #f2f2f2;
}

.custom tr:hover {
  opacity: 1;
  background-color: #dee2e6;
}

.custom thead tr th {
  border-bottom-width: 1px;
  padding-top: 4px;
  padding-bottom: 4px;
  text-align: center !important;
  color: #9A9A9A;
  text-transform: uppercase;
  font-size: 0.75rem;
  font-weight: 400;
}

.custom tr {
  font-size: 14px;
}

</style>